export const SOLUTIONS_LOGIN = 'solutions:webui:login'

export default function isAllowed(context) {
    return (
        context.permissions.includes(SOLUTIONS_LOGIN) ||
        context.data.is_global_admin
    )
}
